/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageDeliveryMethodPageResponse } from '../../models/page-delivery-method-page-response';

export interface GetDeliveryMethods$Params {

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;
}

export function getDeliveryMethods(http: HttpClient, rootUrl: string, params?: GetDeliveryMethods$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDeliveryMethodPageResponse>> {
  const rb = new RequestBuilder(rootUrl, getDeliveryMethods.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageDeliveryMethodPageResponse>;
    })
  );
}

getDeliveryMethods.PATH = '/delivery/methods';
